import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, FileSearch } from "lucide-react";

const CALENDLY_URL = "https://cal.com/mindways/discovery-call";

export default function FinalCTA({ onShortlist }) {
  const scrollToShortlist = () => {
    const el = document.querySelector("#get-shortlist");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      style={{
        padding: "100px 0",
        backgroundColor: "#0F172A",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background decor */}
      <div style={{
        position: "absolute",
        top: "-80px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "600px",
        height: "600px",
        borderRadius: "50%",
        background: "radial-gradient(circle, rgba(43,47,158,0.4) 0%, transparent 70%)",
        pointerEvents: "none",
      }} />
      <div style={{
        position: "absolute",
        bottom: "-60px",
        right: "10%",
        width: "300px",
        height: "300px",
        borderRadius: "50%",
        backgroundColor: "rgba(245,160,0,0.08)",
        pointerEvents: "none",
      }} />

      <div style={{ maxWidth: "800px", margin: "0 auto", padding: "0 24px", textAlign: "center", position: "relative", zIndex: 1 }}>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span style={{ fontSize: "11px", fontWeight: "700", letterSpacing: "0.15em", textTransform: "uppercase", color: "#F5A000", fontFamily: "'DM Sans', sans-serif" }}>
            Start Your Journey
          </span>
          <h2 style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: "clamp(32px, 5vw, 56px)",
            fontWeight: "700",
            color: "#fff",
            margin: "16px 0 20px",
            lineHeight: "1.15",
          }}>
            Ready to plan this properly?
          </h2>
          <p style={{ fontSize: "18px", color: "rgba(255,255,255,0.75)", fontFamily: "'DM Sans', sans-serif", margin: "0 0 48px", lineHeight: "1.7", maxWidth: "500px", marginLeft: "auto", marginRight: "auto" }}>
            Book a strategy call and get a clear roadmap for your next steps. No commitments. No shortcuts.
          </p>

          <div style={{ display: "flex", flexWrap: "wrap", gap: "16px", justifyContent: "center" }}>
            <button
              data-testid="final-cta-book-call-btn"
              onClick={() => window.open(CALENDLY_URL, "_blank")}
              style={{
                backgroundColor: "#F5A000",
                color: "#fff",
                border: "none",
                padding: "18px 40px",
                borderRadius: "6px",
                fontSize: "17px",
                fontWeight: "700",
                cursor: "pointer",
                fontFamily: "'DM Sans', sans-serif",
                boxShadow: "0 8px 32px rgba(245,160,0,0.4)",
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                transition: "all 0.25s",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 16px 40px rgba(245,160,0,0.5)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 8px 32px rgba(245,160,0,0.4)"; }}
            >
              Book a Strategy Call <ArrowRight size={18} />
            </button>

            <button
              data-testid="final-cta-shortlist-btn"
              onClick={scrollToShortlist}
              style={{
                backgroundColor: "transparent",
                color: "#fff",
                border: "2px solid rgba(255,255,255,0.35)",
                padding: "18px 40px",
                borderRadius: "6px",
                fontSize: "17px",
                fontWeight: "600",
                cursor: "pointer",
                fontFamily: "'DM Sans', sans-serif",
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                transition: "all 0.25s",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.7)"; e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.05)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.35)"; e.currentTarget.style.backgroundColor = "transparent"; }}
            >
              <FileSearch size={18} /> Request a Shortlist Review
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
